import React, { useEffect, useRef, useState } from 'react'
import i18next from 'i18next'
import { useNavigate } from 'react-router'
import { getQueryParams } from '../utils/UtilityFunctions'
import { Container, Grid, Typography, Button, Box, Accordion, AccordionSummary, AccordionDetails, Link } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import imgurl from '../assests/images/imgurl';
import LanguageSelector from '../LanguageSelector';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useSelector } from 'react-redux';

const C1 = () => {

  const navigate = useNavigate()
  const [showFixedButton, setShowFixedButton] = useState(false);
  const mainRef = useRef(null);
  const locale = useSelector((state) => state.language.langData);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (!window.cordova) {
      let isMobile = /iPhone|iPod|iPad|Android/i.test(navigator.userAgent);
      if (!isMobile) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    }
  }, []);

  useEffect(() => {
    let params = getQueryParams(window.location.href)
    // console.log("params>>>", params, window.location.href.split('#')[1].split('/')[1].split('?')[0]);
    if(params?.params?.gender && params.params.gender) {
      localStorage.setItem('gender', params.params.gender)
    } else {
      localStorage.setItem('gender', 'male')
    }
    localStorage.setItem('channel', 'alopexia-ads')
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = window.innerHeight;
      // Show button after scrolling 20% of div height
      const scrolledPercent = (scrollTop / (scrollHeight - clientHeight)) * 100;
      console.log("scrolledPercent", scrolledPercent);
      if (scrolledPercent > 10) {
        setShowFixedButton(true);
      } else {
        setShowFixedButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [])

  const goToLogin = () => {
    let url = `https://alopexia.com/hair-test/#/loginpage`;
    window.open(url, "_self");
  }

  return (
    <div className='promopage-campaign-c1' ref={mainRef}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            className='applogo'
            sx={{ mr: 2 }}
          >
           <img src={imgurl.alopexiaLogo}></img>
          </IconButton>
         <div className='headercontentholder'>
          {
            !isMobile &&
              <Button 
                onClick={() => navigate('/tutorial')} 
                color="inherit"
              >
                {i18next.t("Take the Test")}
              </Button>
          }
          <LanguageSelector/>
          <Button 
            onClick={() => 
              // navigate('/hair-test/#/loginpage')
              goToLogin()
            } 
            className='text-transform-inherit'
            color="inherit"
          >
            {i18next.t("Login")}
          </Button>
          </div>
        </Toolbar>
      </AppBar>
      <div className='herosectiondiv'>
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Grid container spacing={2} alignItems="center">
            {/* Left Section */}
            <Grid item xs={12} sm={5} lg={5}>
              {/* You can place left-side image or content here */}
            </Grid>

            {/* Right Section */}
            <Grid
              item
              xs={12}
              sm={7}
              lg={7}
              sx={{ textAlign: { xs: 'center', sm: 'left' } }}
              className="landingPagerightsection"
            >
              <Typography
                variant="h6"
                sx={{ mt: 3 }}
                className={isMobile ? "campaignStarttext mobile" : "campaignStarttext"}
              >
                {i18next.t(
                  'In two minutes, discover your exact hair loss stage and what to do about it.'
                )}
              </Typography>

              <Typography
                variant="subtitle1"
                sx={{ mt: 2 }}
                className="poweredBytext"
              >
                {i18next.t('Private. Fast. Hair Test Powered by AI.')}
              </Typography>

              <Box sx={{ mt: 2 }} className="stepWiseworking">
                <Typography variant="body1">• {i18next.t('Detects your hair loss stage')}</Typography>
                <Typography variant="body1">• {i18next.t('Works on all hair types')}</Typography>
                <Typography variant="body1">• {i18next.t('Free, instant results')}</Typography>
              </Box>

              <Button className='commonButton mt-20px' onClick={() => navigate('/tutorial')}>
                {i18next.t("Start my hair loss test")}
              </Button>
            </Grid>
          </Grid>
        </Container>
      </div>
      <div className='secondfold'>
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <div className='startHairlosswrapper'>
            <Typography className='findStageheader'>
              {i18next.t("The Most Advanced Hair")} <br/> {i18next.t("Loss Test Online")}
            </Typography>

            <Container className='advancedGridsection'>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4} lg={4}>
                  <div className='scalpInfo'>
                    <Typography>
                      • {i18next.t("Aloxa compares your scalp photos with")} 
                      <span>{i18next.t("100,000+ data points")}</span> 
                      {i18next.t("to reveal the earliest signs of hair loss.")}
                    </Typography>
                  </div>
                </Grid>

                <Grid item xs={12} sm={8} lg={8}>
                  <Container className='formenWomensection'>
                    <Grid container spacing={2}>
                      <Grid item xs={6} sm={6} lg={6}>
                        <div className='forMensection maleContent'>
                          <img src={imgurl.man} alt='man icon'></img>
                          <Typography className='introText'>{i18next.t("For Men")}:</Typography>
                          <Typography>{i18next.t("Receding hairline or thinning crown")}</Typography>
                        </div>
                      </Grid>

                      <Grid item xs={6} sm={6} lg={6}>
                        <div className='forMensection femaleContent'>
                          <img src={imgurl.woman} alt='woman icon'></img>
                          <Typography className='introText'>{i18next.t("For Women")}:</Typography>
                          <Typography>{i18next.t("Widening part or overall hair density loss")}</Typography>
                        </div>
                      </Grid>
                    </Grid>
                  </Container>
                </Grid>
              </Grid>
            </Container>

            <Button 
              className="startTestbtn"
              sx={{ mt: 3 }}
              onClick={() => navigate('/tutorial')}
            >
              {i18next.t("Start My Hair Loss Test")}
            </Button>
          </div>
        </Container>
      </div>
      <div className='thirdfold'>
        <div className='startHairlosswrapper'>
          <Typography className='findStageheader'>
            {i18next.t("3 Simple Steps.")} <br/> {i18next.t("Instant Results.")}
          </Typography>

          <Container>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} lg={4}>
                <div className='stepsFortest mt-3'>
                  <Container>
                    <Grid container spacing={2}>
                      <Grid item xs={3} sm={3} lg={3}>
                        <div className='iconBg'>
                          <img src={imgurl.camera} alt='camera icon'></img>
                        </div>
                      </Grid>

                      <Grid item xs={9} sm={9} lg={9} className='content stepsContent'>
                        <Typography className='headerText'>{i18next.t("Upload scalp photos")}</Typography>
                        {/* <Typography className='secondaryText'>Take quick photos of your scalp</Typography> */}
                      </Grid>
                    </Grid>
                  </Container>
                </div>
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <div className='stepsFortest mt-3'>
                  <Container>
                    <Grid container spacing={2}>
                      <Grid item xs={3} sm={3} lg={3}>
                        <div className='iconBg'>
                          <img src={imgurl.ai} alt='brain icon'></img>
                        </div>
                      </Grid>

                      <Grid item xs={9} sm={9} lg={9} className='content stepsContent'>
                        <Typography className='headerText'>{i18next.t("AI maps your stage")}</Typography>
                        {/* <Typography className='secondaryText'>Advanced analysis on trusted scales</Typography> */}
                      </Grid>
                    </Grid>
                  </Container>
                </div>
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <div className='stepsFortest mt-3'>
                  <Container>
                    <Grid container spacing={2}>
                      <Grid item xs={3} sm={3} lg={3}>
                        <div className='iconBg'>
                          <img src={imgurl.medicalReport} alt='report icon'></img>
                        </div>
                      </Grid>

                      <Grid item xs={9} sm={9} lg={9} className='content stepsContent'>
                        <Typography className='headerText'>{i18next.t("See your free report")}</Typography>
                        {/* <Typography className='secondaryText'>Get results in seconds</Typography> */}
                      </Grid>
                    </Grid>
                  </Container>
                </div>
              </Grid>
            </Grid>
          </Container>

          <Button 
            className="startTestbtn"
            sx={{ mt: 3 }}
            onClick={() => navigate('/tutorial')}
          >
            {i18next.t("Start My Hair Loss Test")}
          </Button>
        </div>
      </div>
      <div className='fourthfold'>
        <div className='startHairlosswrapper findMystageWrapper'>
          <Typography className='findStageheader'>
            {i18next.t("Thinning Hair? You're Not Alone.")}
          </Typography>

          <Container className='factualdata'>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} lg={4}>
                <div className='factOne firstFactbox'>
                  <Typography>{i18next.t("Hair loss is reversible – knowing your stage is step one")}</Typography>
                </div>
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <div className='factOne mt-3'>
                  <Typography>{i18next.t("Most people guess their hair loss stage - and guess wrong")}</Typography>
                </div>
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <div className='factOne mt-3'>
                  <Typography>{i18next.t("Aloxa AI helps you detect hair loss not visible in mirrors and self-exams")}</Typography>
                </div>
              </Grid>
            </Grid>
          </Container>

          {/* <a href='https://aloxa.ai/hair-test/#/loginpage'> */}
            <Button className="startTestbtn" sx={{ mt: 3 }} onClick={() => navigate('/tutorial')}>
              {i18next.t("Find Out My Hair Loss Stage")}
            </Button>
          {/* </a> */}

          <Container className='findStagegrid'>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} lg={6}>
                <div className='actNow'>
                  <Typography className='actEarlytext'>
                    ⚠️ <span className='pl-15px'>{i18next.t("Fewer than 1 in 10 people act early enough to stop hair thinning")}</span>
                  </Typography>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} lg={6}>
                <div className='actNow earlyStagedetection'>
                  <Typography className='actEarlytext'>
                    ✅ <span className='pl-15px'>{i18next.t("Dermatologists agree: Early-stage detection makes all the difference")}</span>
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </Container>
        </div>
      </div>
      <div className='fifthfold'>
        <div className='startHairlosswrapper'>
          <p className='findStageheader'>{i18next.t("Get Your Results Now.")}</p>
          <div className='startYourtest'>
              <p>{i18next.t("Get an instant, private, and accurate hair loss assessment")}</p>
          </div>
        </div>
      </div>
      <div className='sixthfold'>
        <Container className="section-title">
          <Typography variant="h2" data-i18n="faq.title" className='findStageheader'>
            {i18next.t("Frequently Asked Questions")}
          </Typography>
        </Container>

        {/* FAQ Accordion */}
        <Container>
          <div className="questionsMainDiv">
            <div>
              {/* Question 1 */}
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                  data-i18n="faq.questions.0.question"
                >
                  <Typography>{i18next.t("How does the AI Hair Health Test work?")}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className="mb-0" data-i18n="faq.questions.0.answer">
                    {i18next.t("Our AI analyzes photos of your scalp and hair to detect thinning, scalp conditions, and other health indicators. It uses advanced algorithms trained on thousands of images.")}
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* Question 2 */}
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                  data-i18n="faq.questions.1.question"
                >
                  <Typography>{i18next.t("Is my personal data safe?")}</Typography>
                </AccordionSummary>
                <AccordionDetails data-i18n="faq.questions.1.answer">
                  <Typography className="mb-0">
                    {i18next.t("Yes! We are Compliant with Privacy Standards and take your privacy seriously. Your photos and data are encrypted and never shared.")}
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* Question 3 */}
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel3-content"
                  id="panel3-header"
                  data-i18n="faq.questions.2.question"
                >
                  <Typography>{i18next.t("How long does it take to get results?")}</Typography>
                </AccordionSummary>
                <AccordionDetails data-i18n="faq.questions.2.answer">
                  <Typography className="mb-0">
                    {i18next.t("You'll receive your detailed hair health report instantly, usually within few minutes after submitting your photos.")}
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* Question 4 */}
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4-content"
                  id="panel4-header"
                  data-i18n="faq.questions.3.question"
                >
                  <Typography>{i18next.t("Do I need professional equipment to take photos?")}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className="mb-0" data-i18n="faq.questions.3.answer">
                    {i18next.t("No. All you need is your smartphone! We guide you through the process to ensure clear and accurate images.")}
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* Question 5 */}
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel5-content"
                  id="panel5-header"
                  data-i18n="faq.questions.4.question"
                >
                  <Typography>{i18next.t("Is the test suitable for all hair types and stages of hair loss?")}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className="mb-0" data-i18n="faq.questions.4.answer">
                    {i18next.t("Absolutely. Our AI works with all hair types, colors, and hair loss stages, providing personalized insights for everyone.")}
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* Question 6 */}
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel6-content"
                  id="panel6-header"
                  data-i18n="faq.questions.5.question"
                >
                  <Typography>{i18next.t("I'm unable to take the test. What should I do?")}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <div>
                    <span className="mb-0" data-i18n="faq.questions.5.answer1">
                      {i18next.t("If you're experiencing issues and cannot take the test, please don't worry — we're here to help. Reach out to us at")}{' '}
                    </span>
                    <a
                      href="mailto:contact@aloxa.ai"
                      className="text-decoration-underline text-dark"
                      data-i18n="faq.questions.5.answer2"
                    >
                      contact@aloxa.ai
                    </a>
                    <span data-i18n="faq.questions.5.answer3">
                      {' '}
                      {i18next.t("and our support team will get back to you as soon as possible.")}
                    </span>
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
        </Container>
      </div>
      {
        showFixedButton &&
        <div className="fixedBtnWrapper scroll-top stickyBackground">
          <Button className="evaluationBtn" onClick={() => navigate('/tutorial')}>
            {i18next.t(
              locale === 'en' ?
                "Start my hair loss test" :
              locale === 'fr' ?
                "Start my hair loss test " :
              locale === 'es' ?
                "Start my hair loss test " :
              "Start my hair loss test"
            )}
          </Button>
          <p onClick={() => goToNext()} className='ctasubtext'>{i18next.t("Click Here")}</p>
        </div>
      }
      <div className={!isMobile ? 'footerSection' : 'footerSection mb-70'}>
      <div className='footerDetails'>
        <div className='logoAddress'>   
          <div className='footerLogo'>
            <img src={imgurl.hairlossaiLogo}></img>
          </div>
          <div className='footerAddress'>
            <Typography>Centa  Biotech SL,Alameda Principal 11, </Typography>
            <Typography>29001 Malaga, Spain. </Typography>
          </div>
        </div>
        <div className="mt-5px footerDiv">
          <div>
            <Typography className='footerName rightsText'>{i18next.t("@2025 Alopexia. All rights reserved.")}</Typography>
          </div>
          <div className='footerLinks'>   
            <div>
              <a href="https://alopexia.com/privacy-policy/" className="linkName">
              <Typography className="footerName">• {i18next.t("Privacy Policy")}</Typography>
              </a>
            </div>
            <div className='text-left'>
              <a href="https://alopexia.com/terms-of-service/" className="linkName">
              <Typography className="footerName">• {i18next.t("Terms of Service")}</Typography>
              </a>
            </div>
            <div>
              <a href="https://alopexia.com/contact-information/" className="linkName">
              <Typography className="footerName">• {i18next.t("Contact Information")}</Typography>
              </a>
            </div>
            {/* <div>
            <Link to="https://alopexia.com/policies/refund-policy" className="linkName">
            <Typography className="footerName">• {i18next.t("Refund Policy")}</Typography>
            </Link>
            </div> */}
            {/* <div>
            <Link to="" className="linkName">
            <Typography className="footerName">• {i18next.t("Cookie Preferences")}</Typography>
            </Link>
            </div> */}
            {/* <div>
            <Link to="/feedback" className="linkName">
            <Typography className="footerName">• {i18next.t("Feedback Form")}</Typography>
            </Link>
            </div> */}
          </div>    
          {/* <div className='centabioLink'>
            <a href="https://www.centabio.com/" target='_blank'>www.centabio.com</a>
          </div> */}
        </div>
      </div>
    </div>
    </div>
  )
}

export default C1